const MuiMasonry = {
  styleOverrides: {
    root: {
      padding: 0,
    },
  },
}

export default MuiMasonry
